import axios from '@/axios'

export default {
  /**
   * Create a new admin report
   * @param {Object} data - Report data
   * @returns {Promise}
   */
  create(data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/admin-reports', data)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },

  /**
   * Get all admin reports
   * @returns {Promise<Array>}
   */
  getAll() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/admin-reports')
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },

  /**
   * Get a specific admin report
   * @param {number} id - Report ID
   * @returns {Promise}
   */
  getById(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/admin-reports/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },

  /**
   * Update report status
   * @param {number} id - Report ID
   * @param {string} status - New status (pending, investigating, resolved, closed)
   * @returns {Promise}
   */
  updateStatus(id, status) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/admin-reports/${id}/status`, { status })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },

  /**
   * Request investigation for a report
   * @param {number} id - Report ID
   * @returns {Promise}
   */
  requestInvestigation(id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/admin-reports/${id}/investigate`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
